import { ICoSo } from "../../../model/respone/category/ICoSo"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eCoSoActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ICoSo[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | ICoSo,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as ICoSo,
    SAVE_SUCCESS: {} as ICoSo,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


}
export const eCoSoActionTypeIds = generateActionTypeIds(eCoSoActionTypeDefine, "CO_SO")

export type ICoSoActions = IGenericActionType<typeof eCoSoActionTypeDefine, "CO_SO">